import { IAttachmentContainer } from './attachment.model';
import { IAttendanceClocking, ILabourClocking } from './clocking.model';
import { ITechComment } from './technicianComments.model';

export interface IRequestQueueBase {
  id: number;
  immediate: boolean;
  group: RequestQueueGroup;
  type: RequestQueueType;
  error: string;
}

export interface IClockingRequestQueueItem extends IRequestQueueBase {
  data: IAttendanceClocking | ILabourClocking;
}

export interface ITechCommentRequestQueueItem extends IRequestQueueBase {
  data: ITechComment;
}

export interface IVehicleAttachmentRequestQueueItem extends IRequestQueueBase {
  data: IAttachmentContainer;
}

export enum RequestQueueGroup {
  Clocking,
  TechComment,
  VehicleAttachment,
}

export enum RequestQueueType {
  TechAttendanceOn,
  TechAttendanceOff,
  TechLabourOn,
  TechLabourOff,
  TechComment,
  VehicleAttachment,
}